import { FormTextField } from 'src/components/Forms';
import { ClientSegmentFormField } from './client-segment-form.types';

interface ClientSegmentFormFieldsProps {
  disabled?: boolean;
}

const SEGMENT_NAME_HELPER = 'Internal label. Visible only to your team.';
const DISPLAY_NAME_HELPER = 'What customers see in receipts, plan names, and outbound emails.';

export const ClientSegmentFormFields = ({ disabled }: ClientSegmentFormFieldsProps) => (
  <>
    <FormTextField
      type="textfield"
      name={ClientSegmentFormField.Name}
      label="Segment name"
      required="Segment name is required"
      disabled={disabled}
      showErrorText
      textFieldProps={{
        helperText: SEGMENT_NAME_HELPER,
        inputProps: { 'data-testid': 'client-segment-name-input' },
      }}
    />
    <FormTextField
      type="textfield"
      name={ClientSegmentFormField.DisplayName}
      label="Display name"
      required="Display name is required"
      disabled={disabled}
      showErrorText
      textFieldProps={{
        helperText: DISPLAY_NAME_HELPER,
        inputProps: { 'data-testid': 'client-segment-display-name-input' },
      }}
    />
  </>
);
